import { render } from "./InputNumber.vue?vue&type=template&id=0ff1eb70&scoped=true"
import script from "./InputNumber.vue?vue&type=script&lang=ts"
export * from "./InputNumber.vue?vue&type=script&lang=ts"

import "./InputNumber.vue?vue&type=style&index=0&id=0ff1eb70&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0ff1eb70"

export default script